import React, { useState, useCallback, useMemo } from 'react';
import { useMutation } from '@apollo/client';
import TextInput from '../common/TextInput';
import SelectInput from '../common/SelectInput';
import Button from '../common/Button';
import { PermissionStatus } from '../../types/users';
import { useTranslation } from 'react-i18next';
import { CREATE_USER } from '../../graphql/mutations/users';

interface RegisterUserProps {
    closeCreateForm: () => void;
}

const RegisterUser: React.FC<RegisterUserProps> = ({ closeCreateForm }) => {
    const { t } = useTranslation('users');

    const [createUserMutation] = useMutation(CREATE_USER);

    const [username, setUsername] = useState<string>('');
    const [department, setDepartment] = useState<string>('');
    const [job, setJob] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [permission, setPermission] = useState<PermissionStatus>('admin');


    const permissionList = useMemo(() => [
        { value: 'admin', label: t('admin') },
        { value: 'general', label: t('general') }
    ], []);

    const handleSetPermission = useCallback((value: string) => {
        if (value === 'admin' || value === 'general') setPermission(value);
    }, []);

    const handleCreateUser = () => {
        createUserMutation({
            variables: {
                name: username,
                email: email,
                division: department,
                position: job,
                role: permission,
            }
        }).then(() => {
            closeCreateForm();
        }).catch((error) => {
            console.error('Error creating user:', error);
            alert('Failed to create user. Please try again.');
        });
    };

    return (
        <div>
            <h3>{t('add new user')}</h3>
            <TextInput
                label={t('username')}
                inputValue={username}
                onChange={setUsername}
            />
            <TextInput
                label={t('department')}
                inputValue={department}
                onChange={setDepartment}
            />
            <TextInput
                label={t('job')}
                inputValue={job}
                onChange={setJob}
            />
            <TextInput
                label={t('mail address')}
                inputValue={email}
                onChange={setEmail}
            />
            <SelectInput
                label={t('permission')}
                options={permissionList}
                selectedValue={permission}
                onChange={handleSetPermission}
            />
            <Button label={t('register')} onClick={handleCreateUser} />
        </div>
    );
};

export default RegisterUser;
